import {
  CustomIconKeyValuePairs,
  InbuiltIconKeyValuePairs,
} from "../../../data/icons";
import type { KeyValuePairDTO } from "../../../types/dtos/KeyValuePairDTO";
import type { KeyValuePairIconProps } from "@repo/types/ui/keyValuePairs";

export function KeyValuePairIcon({
  keyValuePair,
}: {
  keyValuePair: KeyValuePairDTO;
}) {
  const keyValuePairIcon: KeyValuePairIconProps | undefined = [
    ...InbuiltIconKeyValuePairs,
    ...CustomIconKeyValuePairs,
  ].find((kvp) => kvp.id === keyValuePair.Icon);
  const Icon = keyValuePairIcon?.icon;

  if (!keyValuePair || !Icon) {
    return null;
  }

  return (
    <div
      className="p-1 rounded"
      style={{
        backgroundColor: keyValuePair.BgColorHex,
        color: keyValuePair.TextColorHex ?? "#575757",
      }}
    >
      <Icon size={16} />
    </div>
  );
}
